import React, { useContext } from 'react';
import { Navigate } from 'react-router';

import { UserContext } from './context/UserContext';

const SuperadminGuard = ({ children }) => {
  const { user } = useContext(UserContext);

  // Wait for user data to load before deciding
  if (!user) return null;

  if (!user?.permissions?.superadmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default SuperadminGuard;
